// extracted by mini-css-extract-plugin
module.exports = {"tiltRight":"-MQ__Yx6oDeuYjQBf662V","tiltLeft":"_37RovQ29lndIl6Av0oVCI"};